var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("modal", {
    staticClass: "panel-activity p-0",
    attrs: {
      show: _vm.showModal,
      "show-content": _vm.showContent,
      "page-title": _vm.modalTitle,
      "close-btn": _vm.closeBtn,
      position: _vm.position,
      size: _vm.size,
    },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "ct-aside-control-item" },
              [
                _c("infinity-scroll", {
                  ref: "scroll",
                  attrs: {
                    "class-wrapper-list": "ct-aside-control-body",
                    "load-more-records": _vm.txtLoadMoreRecords,
                    "no-records": _vm.txtNoRecords,
                    url: _vm.url,
                  },
                  on: { onLoadData: _vm.onLoadData },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "ct-aside-control-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "title d-flex justify-content-between align-items-center w-100",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.modalTitle) +
                                      "\n              "
                                  ),
                                  _vm.reloadBtn
                                    ? _c(
                                        "span",
                                        { staticClass: "cursor-pointer" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: _vm.assetsPathTheme(
                                                "/icons/refresh.svg"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.reloadData.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "list",
                      fn: function ({ item }) {
                        return [
                          _c("ItemMap", {
                            attrs: {
                              item: item,
                              "txt-link-map": `${_vm.idPanel}.item.link_map`,
                              "label-code": `${_vm.idPanel}.item.code`,
                              "label-address": `${_vm.idPanel}.item.address`,
                              "label-created-at": `${_vm.idPanel}.item.created_at`,
                              "label-days-overdue": `${_vm.idPanel}.item.days_overdue`,
                            },
                            on: { selectItem: _vm.onSelectItem },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }